<div class="min-h-dvh bg-[#f6f4f0] text-midnight-indigo overflow-x-hidden">

  <!-- Simulación de web del propietario -->
  <header class="border-b border-[#e8e4dc] bg-white/90 backdrop-blur-sm sticky top-0 z-10">
    <div class="max-w-4xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-between gap-4">
      <div class="flex items-center gap-2.5 min-w-0">
        <div class="h-9 w-9 rounded-full bg-midnight-indigo/10 flex items-center justify-center shrink-0">
          <lucide-icon name="building-2" [size]="18" class="text-midnight-indigo" />
        </div>
        <span class="text-[14px] font-bold truncate">Mi negocio local</span>
      </div>
      <nav class="hidden sm:flex items-center gap-5 text-[12px] font-medium text-slate-blue">
        <span>Inicio</span>
        <span>Espacios</span>
        <span>Contacto</span>
      </nav>
    </div>
  </header>

  <main class="max-w-4xl mx-auto px-4 sm:px-6 py-8 sm:py-12">
    <p class="inline-flex items-center gap-1.5 rounded-full border border-action-blue/25 bg-action-blue/5
              px-3 py-1 text-[11px] font-semibold text-action-blue mb-4">
      <lucide-icon name="eye" [size]="13" />
      Vista previa para propietarios
    </p>

    <h1 class="text-[26px] sm:text-[32px] font-bold tracking-tight leading-tight">
      {{ spaceName() }}
    </h1>
    <p class="mt-3 max-w-2xl text-[14px] sm:text-[15px] leading-relaxed text-slate-blue">
      Así verán tus clientes el calendario cuando lo incrustes en tu web:
      pulsan un día libre y continúan la reserva en TimeFlexRent.
    </p>

    @if (loading()) {
      <div class="mt-8 flex items-center justify-center gap-2 py-20 text-steel-gray">
        <lucide-icon name="loader-circle" [size]="20" class="animate-spin" />
        <span class="text-[13px]">Cargando ejemplo…</span>
      </div>
    } @else if (error()) {
      <div class="mt-8 rounded-2xl border border-red-200 bg-red-50 px-5 py-8 text-center">
        <p class="text-[14px] text-red-800">{{ error() }}</p>
      </div>
    } @else {
      <section class="mt-8 rounded-2xl border border-[#e8e4dc] bg-white shadow-[0_8px_30px_rgba(11,53,88,0.08)] overflow-hidden">
        <div class="px-4 sm:px-5 py-3 border-b border-pale-gray bg-cloud-mist/50 flex flex-wrap items-center justify-between gap-2">
          <p class="text-[11px] font-semibold uppercase tracking-wider text-steel-gray">
            Widget incrustado en tu página
          </p>
          <span class="text-[10px] text-steel-gray">Prueba a pulsar un día libre para reservar</span>
        </div>

        <div class="p-4 sm:p-5 bg-[#fafafa]">
          <iframe
            [src]="embedSafeUrl()"
            [style.height.px]="frameHeight()"
            width="100%"
            class="block w-full rounded-xl border-0 shadow-[0_4px_20px_rgba(11,53,88,0.12)] bg-white"
            allow="popups"
            loading="lazy"
            [title]="'Disponibilidad — ' + spaceName()">
          </iframe>
        </div>
      </section>

      <p class="mt-6 text-center text-[12px] text-steel-gray leading-relaxed">
        Esta página es solo una demostración. En tu web pegarás el código HTML que te damos en
        <strong class="text-midnight-indigo">Mis espacios → Compartir → Incrustar en tu web</strong>.
      </p>
    }
  </main>
</div>
